import React, { useEffect, useState } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { Link, useNavigate, useParams } from "react-router-dom";
import { categories } from "../data/category";
import ListViewer from "../components/ListViewer";
import { getALLCategory, getAllProducts } from "../apis/config";
import { getAllBanner } from "../apis/authApi";
import ComingSoon from "./ComingSoon";
// import image from "../../public/assets/1.jpg"

const CategoryPage = () => {
  const { category } = useParams();
  const [length, setLength] = useState(false);
  const navigate = useNavigate();
  const [categorys, setCategorys] = useState([]);
  const [products, setProducts] = useState([]);
  const [banner, setBanner] = useState("");
  useEffect(() => {
    getALLCategory()
      .then((res) => setCategorys(res.data))
      .catch((err) => console.log(err));
    getAllProducts()
      .then((res) => setProducts(res.data))
      .catch((err) => console.log(err));
  }, []);
  useEffect(() => {
    getAllBanner()
      .then((res) =>
        setBanner(
          res.data.find(
            (b) => b?.name?.toLowerCase() === category.toLowerCase()
          )
        )
      )
      .catch((err) => console.log(err));
  }, [category]);
  const subcat = categorys.find((cat) => cat.name === category)?.subcategories;
  const datas = products.filter((pro) =>
    pro.label.some((p) => p.toLowerCase() === "best sale")
  );
  return (
    <>
      {/* <Header/> */}
      <div className=" px-5 md:px-10">
        <h6 className="  text-gray-400 text-[10px] mt-2 capitalize text-center">
          <span
            className=" hover:text-black cursor-pointer"
            onClick={() => navigate("/")}
          >
            Home
          </span>{" "}
          {">"} <span className=" text-gray-700">{category}</span>
        </h6>
        <h3 className=" text-primary font-semibold capitalize py-5 text-center text-xl">
          {category}
        </h3>
        {banner && (
          <div className="h-[200px] w-full mb-5">
            <img
              src={banner.image}
              alt={category}
              className="w-full h-full object-cover"
            />
          </div>
        )}
        <h3 className=" text-primary font-semibold capitalize py-5 text-center text-xl">
          Shop by category
        </h3>
        {subcat?.length > 0 ? (
          <>
            {" "}
            <div className=" grid grid-cols-2 sm:grid-cols-3 md:grid-cols-6 gap-2 justify-center items-center">
              {(length ? subcat : subcat?.slice(0, 12))?.map((sub, index) => (
                <div
                  key={index}
                  className=" bg-gray-100 flex flex-col justify-center items-center p-2 gap-2 cursor-pointer hover:text-primary border-2 hover:border-primary"
                  onClick={() => navigate(`/category/${category}/${sub.name}`)}
                >
                  <div className=" w-32 h-32">
                    <img
                      src={sub.image}
                      alt={sub.name}
                      className=" w-full h-full object-cover"
                    />
                  </div>
                  <h4 className=" text-[12px] font-medium text-center capitalize ">
                    {sub.name}
                  </h4>
                </div>
              ))}
            </div>
            {subcat?.length > 12 && (
              <div
                className=" text-red-600 text-[12px] text-center py-5 cursor-pointer"
                onClick={() => setLength(!length)}
              >
                {length
                  ? "Show less ->"
                  : `Show all Categories (${subcat?.length}) ->`}
              </div>
            )}
          </>
        ) : (
          <ComingSoon />
        )}
        <h3 className=" text-primary font-semibold capitalize text-center text-xl pt-5">
          Shop best seller
        </h3>
        {/* <h3 className="font-bold py-5">Best Seller</h3> */}
        <div className=" grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-5 py-5">
          {datas.map((data, index) => (
            <div key={index} className=" flex border-gray-300  h-[120px] overflow-hidden border-[1px] w-[350px]">
              <div className=" w-[120px] h-[120px]">
                <img
                  src={data.images[0]}
                  alt="image"
                  className=" w-full h-full object-cover object-center"
                />
              </div>
              <div className=" p-5 flex flex-col gap-2">
                <h3 className=" font-bold hover:text-primary cursor-pointer">
                  <Link to={`/products/${data._id}`} title={data.name}>
                    {data.name?.length > 15
                      ? `${data.name.slice(0, 15)}...`
                      : data.name}
                  </Link>
                </h3>
                <h4 className=" text-[15px] font-boldw-fit text-red-600 font-bold">
                  {" "}
                  &#8377; {data.salePrice}{" "}
                  <span className=" line-through text-gray-700 font-normal text-[12px]">
                    &#8377; {data.price}
                  </span>
                </h4>
                <button
                  className=" w-fit text-[12px] uppercase font-bold hover:text-primary hover:border-primary border-black border-b-2 hover:border-0 duration-150 ease-linear"
                  onClick={() => navigate(`/products/${data._id}`)}
                >
                  Buy Now
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
      {/* <Footer/> */}
    </>
  );
};

export default CategoryPage;
